import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CognitoAuthProvider from './components/CognitoAuthProvider';
import { AuthTokenProvider } from './services/AuthService';
import posthog from 'posthog-js';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2026-01-30',
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = (
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <BrowserRouter>
        <CognitoAuthProvider>
          <AuthTokenProvider>
            <App />
          </AuthTokenProvider>
        </CognitoAuthProvider>
      </BrowserRouter>
    </PostHogErrorBoundary>
  </PostHogProvider>
);

// Only wrap with StrictMode in development
if (process.env.NODE_ENV === 'development') {
  root.render(
    <React.StrictMode>
      {renderApp}
    </React.StrictMode>
  );
} else {
  root.render(renderApp);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA push (best-effort)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').then(reg => {
    console.log('Service worker registered:', reg.scope)
  }).catch(err => {
    console.warn('Service worker registration failed:', err)
  })
}
